import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";
import { Phone } from "lucide-react";

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-[#281245] bg-[#05020a] pt-20" data-testid="site-footer">
    <div className="mx-auto grid max-w-[1400px] gap-12 px-5 md:grid-cols-12 md:px-10">
      <div className="md:col-span-6">
        <LogoMark className="h-12 w-12" />
        <p className="mt-6 max-w-sm text-[#cbbbe6]">Your favourite reseller. Luxury &amp; designer finds, hand-picked in BC and shipped across Canada.</p>
      </div>
      <div className="md:col-span-3">
        <p className="font-mono-j text-xs uppercase tracking-[0.3em] text-[#a78bce]">Shop</p>
        <ul className="mt-4 space-y-2 text-[#e9ddfb]">
          <li><Link to="/shop" className="hover:text-[#d8b4fe]" data-testid="footer-shop-link">All pieces</Link></li>
          <li><Link to="/reviews" className="hover:text-[#d8b4fe]" data-testid="footer-reviews-link">Reviews</Link></li>
          <li><Link to="/#request" className="hover:text-[#d8b4fe]" data-testid="footer-request-link">Request an item</Link></li>
          <li><Link to="/account" className="hover:text-[#d8b4fe]" data-testid="footer-account-link">My claims</Link></li>
        </ul>
      </div>
      <div className="md:col-span-3">
        <p className="font-mono-j text-xs uppercase tracking-[0.3em] text-[#a78bce]">Studio</p>
        <ul className="mt-4 space-y-2 text-[#e9ddfb]">
          <li>British Columbia, Canada</li>
          <li>Ships across Canada</li>
          <li>Claim online, we reach out</li>
          <li><a href="sms:+16473754053" className="hover:text-[#d8b4fe]" data-testid="footer-text-link"><Phone className="mr-1.5 inline h-4 w-4 text-[#a855f7]" />Text us — text only</a></li>
          <li><a href="https://www.instagram.com/shopmaisonpierre" target="_blank" rel="noreferrer" className="hover:text-[#d8b4fe]" data-testid="footer-instagram-link">Follow @shopmaisonpierre</a></li>
        </ul>
      </div>
    </div>
    <p className="font-display pointer-events-none mt-16 select-none whitespace-nowrap px-4 text-center text-[17vw] leading-[0.8] text-outline">Maison Pierre</p>
    <div className="mx-auto flex max-w-[1400px] justify-between border-t border-[#1c0d31] px-5 py-6 text-xs text-[#a78bce] md:px-10">
      <span>© 2026 Maison Pierre &amp; Co.</span>
      <span className="font-mono-j">BC / CANADA</span>
    </div>
  </footer>
);
